export default __webpack_public_path__ + "static/media/IconDesc_ChristmasTreeBare.256.8236e3ff.png";